import React, {useContext} from 'react'
import createStickySider from 'views/AppLocals/factory/createStickySider'
import {AppEntities} from '../../enums'
import createStatusBar from '../../factory/createStatusBar'
import OrganizationOpeningCourses from '../holders/OrganizationOpeningCourses'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {OrganizationChurchOrAnnouncement, OrganizationUpcomingTimetableBlock} from "../holders/OrganizationInfo";
import {OrganizationContactSider, OrganizationShopsBlock} from "../holders/OrganizationContactInfo";
import {OrganizationUpcomingEventBlock} from "../holders/OrganizationEventList";
import {OrganizationExaminations} from "../holders/OrganizationExaminations";
import useTranslate from "../../../../modules/local/useTranslate";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {GamePromo, LivestreamMass} from "../../User/components/UserSider";
import {WrapperBlockSider} from "./WrapperBlockSider";
import {renderIf} from "../../../Shared";
import {BsMagic} from "react-icons/bs";
import {Link} from "react-router-dom";
import {BiImageAdd, BiSolidChurch} from "react-icons/bi";
import {PiPhonePlusFill, PiPlusCircleFill} from "react-icons/pi";
import {TbLinkPlus} from "react-icons/tb";
import {user_fetchSuggestionOrganizationAppChoices_Api} from "../../../../apis";
import {staticPaths} from "../../../../routes/staticPaths";
import EntityList from "../../EntityList";
import {Avatar} from "antd";
import getAvatar from "../../../../helpers/getAvatar";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getTitle from "../../../../helpers/getTitle";
import {OrgType} from "./OrgType";
import {FollowButton} from "../../../../components/Feed/FollowButton";
import {useHistory} from "../../../../modules/navigation/useRouter";

const OrganizationStatusBar = createStatusBar(
    AppEntities.ORGANIZATION,
    OrganizationContainerContext
)

export const CompletePage = ({organization}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {
        avatar, cover_photo,
        description, about,
        linked_pages = [], contacts = [],
    } = organization ?? {}


    const isAdmin = organization?.edit

    return isAdmin && (
        <WrapperBlockSider title={t('complete your page')} icon={<BsMagic size={14} className="text-blue-500"/>} titleColor="text-blue-600">
            <div className="p-3 pt-0 flex flex-col gap-3">
                <div className="text-xs text-color-300 italic tracking-wider">
                    {t('Add more information to complete your community page')}
                </div>
                {renderIf(
                    !avatar || !cover_photo || !description || !about || linked_pages?.length === 0,
                    <div className="flex flex-col flex-1 gap-1">
                        {(!avatar || !cover_photo) && (
                            <span className="px-2 py-1 flex items-center background-50 rounded-lg font-medium text-color-100">
                                    <BiImageAdd size={15} className="mr-1 text-green-500"/>
                                {t('Add profile or cover photos')}
                                </span>
                        )}
                        {(contacts?.length === 0) && (
                            <span className="px-2 py-1 flex items-center background-50 rounded-lg font-medium text-color-100">
                                    <PiPhonePlusFill size={15} className="mr-1 text-blue-500"/>
                                {t('Add contacts information')}
                                </span>
                        )}
                        {(linked_pages?.length === 0) && (
                            <span className="px-2 py-1 flex items-center background-50 rounded-lg font-medium text-color-100">
                                    <TbLinkPlus size={15} className="mr-1 text-primary-500"/>
                                {t('Add linked pages information')}
                                </span>
                        )}
                        {(!description) && (
                            <span className="px-2 py-1 flex items-center background-50 rounded-lg font-medium text-color-100">
                                    <PiPlusCircleFill size={15} className="mr-1 text-green-500"/>
                                {t('Add short description - charism & mission')}
                                </span>
                        )}
                        {(!about) && (
                            <span className="px-2 py-1 flex items-center background-50 rounded-lg font-medium text-color-100">
                                    <PiPlusCircleFill size={15} className="mr-1 text-green-500"/>
                                {t('Add about organization')}
                                </span>
                        )}
                    </div>
                )}
                <div className="text-xs text-color-300 italic tracking-wider">
                    {t(
                        'would you like to go to {page} now',
                        {page: (
                                <Link to={`/workspace/setting?rel=overview`} className="mx-1 font-bold text-secondary-500 not-italic no-underline">
                                    {t('general settings')}
                                </Link>
                            )}
                    )}
                </div>
            </div>
        </WrapperBlockSider>
    )
}

export const OrganizationSuggest = () => {
    const t = useTranslate()
    const history = useHistory()
    return (
        <EntityList
            auto={false}
            sample={3}
            apiInfo={user_fetchSuggestionOrganizationAppChoices_Api}
            refreshKey={user_fetchSuggestionOrganizationAppChoices_Api.path}
            RenderEntity={React.Fragment}
            renderItem={(item) => (
                <div className="px-3 py-2 flex items-center gap-3 hover:background-200 cursor-pointer transition-all duration-300">
                    <Avatar
                        size={44}
                        icon={<BiSolidChurch size={22} className="text-primary-600"/>}
                        src={getAvatar(item)}
                        className="flex flex-center bg-primary-50 rounded-xl flex-shrink-0"
                    />
                    <div className="flex flex-col flex-1 min-w-0">
                        <Link
                            to={getLinkToDetail(item)}
                            className="font-semibold text-sm no-underline leading-snug truncate">
                            {getTitle(item)}
                        </Link>
                        <OrgType item={item} className="font-bold text-2xs text-blue-500 truncate"/>
                    </div>
                    <FollowButton
                        size="small"
                        item={item}
                    />
                </div>
            )}
            renderWrap={(child, count) => !!count && (
                <div className="w-full flex flex-col">
                    <WrapperBlockSider flat={false} title="you might like">
                    <div className="flex flex-col">
                        {child}
                    </div>
                    <div className="my-2 flex justify-end">
                        <span
                            onClick={() => {
                                history.push({
                                    pathname: staticPaths.discovery.pathname,
                                    search: '?' + (new URLSearchParams({tab: 'search', type: 'organization'})).toString(),
                                })
                            }}
                            className="py-1 px-3 cursor-pointer font-medium text-xs text-secondary-500 hover:text-secondary-700">
                            {t('see more')}...
                        </span>
                    </div>
                    </WrapperBlockSider>
                </div>
            )}
        />
    )
}

const OrganizationSticker = () => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)

    return (
        <div className="flex flex-col gap-6 mt-6">
            {/*  TRƯỜNG HỢP ORG CÓ THÔNG TIN */}
            {/* Mỗi khối giờ TỰ QUẢN khung nền/bo góc/bóng đổ của mình (SiderBlockCard, đặt bên trong
                từng file - xem OrganizationInfo.js/OrganizationGroups.js/...) - ở đây chỉ còn xếp
                chồng theo đúng thứ tự với khoảng cách đều nhau (gap-4 md:gap-6, khớp JoinBlock/
                ShopsBlock đã dùng), không gộp chung khung cho các khối không liên quan tới nhau nữa. */}
            {!!isLg && <OrganizationChurchOrAnnouncement/>}
            {!!isLg && !!organization?.id && <OrganizationUpcomingTimetableBlock/>}
            {!!isLg && <OrganizationOpeningCourses/>}
            {!!isLg && <OrganizationExaminations/>}
            {!!isLg && <OrganizationUpcomingEventBlock/>}
            {!!isLg && <OrganizationShopsBlock/>}
            {/* Liên hệ - thông tin tra cứu phụ, đặt cuối cùng (xem OrganizationContactSider) */}
            {/*{!!isLg && <OrganizationContactSider/>}*/}

            {/*  TRƯỜNG HỢP ORG KHÔNG CÓ THÔNG TIN HOẶC MỚI TẠO*/}
            {!!isLg && <OrganizationSuggest/>}
            {!!isLg && <LivestreamMass/>}
            {!!isLg && <GamePromo/>}
            <div className="h-16"/>
        </div>
    )
}

const OrganizationSider = ({Wrapper = 'div', stickySider = true}) =>
    createStickySider({
        Wrapper,
        stickySider,
    })(OrganizationSticker)

export default OrganizationSider
